// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"d5f4e1dc","249":"4327c909","541":"792d72e6","838":"792d72e6","941":"344fc770"}[chunkId] + ".chunk.css";
};